import Vue from 'vue'
import numeral from 'numeral'

Vue.filter('num', value => {
    return numeral(value || '').format('0,0')
})
